import { render } from "./InviteAward.vue?vue&type=template&id=63499652&scoped=true&ts=true"
import script from "./InviteAward.vue?vue&type=script&setup=true&lang=ts"
export * from "./InviteAward.vue?vue&type=script&setup=true&lang=ts"

import "./InviteAward.vue?vue&type=style&index=0&id=63499652&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63499652"],['__file',"src/views/me/InviteAward.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63499652"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63499652', __exports__)) {
    console.log('reload')
    api.reload('63499652', __exports__)
  }
  
  module.hot.accept("./InviteAward.vue?vue&type=template&id=63499652&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('63499652', render)
  })

}


export default __exports__